'use client';

import React from 'react';
import { Box, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import QuickActionBar from './QuickActions/QuickActionBar';
import ConversationList from './History/ConversationList';
import { useAgentContext } from '../context/AgentContext';

export default function WelcomeScreen() {
  const { state } = useAgentContext();

  if (state.showHistory) {
    return <ConversationList />;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        p: '2rem 1.5rem',
        textAlign: 'center',
        gap: '1.5rem',
      }}
    >
      <AutoAwesomeIcon sx={{ fontSize: '2.5rem', color: 'var(--primary-color)' }} />

      <Box>
        <Typography
          variant="h6"
          sx={{
            color: 'var(--sw-white-color)',
            fontWeight: 600,
            mb: 0.5,
          }}
        >
          SkyWatch Enterprise Assistant
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'var(--sw-white-color-90)',
            opacity: 0.7,
            maxWidth: 280,
            mx: 'auto',
          }}
        >
          Search satellite imagery, get pricing, and explore our data products.
        </Typography>
      </Box>

      <QuickActionBar />

      <Typography
        variant="caption"
        sx={{
          color: 'var(--sw-white-color-90)',
          opacity: 0.4,
          fontSize: '0.7rem',
          maxWidth: 260,
          mt: 'auto',
        }}
      >
        AI responses may be inaccurate. Please verify important information.
      </Typography>
    </Box>
  );
}
